<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    <p>{{message}}</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>{{closeLabel}}</button>
    <button (click)="close()" mat-flat-button>{{confirmLabel}}</button>
</mat-dialog-actions>